"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._transformWebClass = void 0;
const _transformWebClass = (classes, uniqueHash) => {
    if (!classes)
        return '';
    return classes
        .trim()
        .replace(/\s+/g, ' ')
        .split(' ')
        .map(item => item + '--' + uniqueHash)
        .join(' ');
};
exports._transformWebClass = _transformWebClass;
//# sourceMappingURL=_transformWebClass.js.map